import React, { useState } from 'react';
import './Debug.css';

function Debug() {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState({});

  const apiUrl = process.env.REACT_APP_API_URL || '/api';

  const testEndpoint = async (name, url, options = {}) => {
    setLoading(prev => ({ ...prev, [name]: true }));
    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          'Content-Type': 'application/json',
          ...options.headers
        }
      });
      
      const data = await response.json();
      setResults(prev => ({
        ...prev,
        [name]: {
          success: true,
          status: response.status,
          data
        }
      }));
    } catch (error) {
      setResults(prev => ({
        ...prev,
        [name]: {
          success: false,
          error: error.message
        }
      }));
    } finally {
      setLoading(prev => ({ ...prev, [name]: false }));
    }
  };

  const tests = [
    {
      name: 'Health Check',
      description: 'Test basic server connectivity',
      run: () => testEndpoint('health', `${apiUrl}/health`)
    },
    {
      name: 'Posts List',
      description: 'Get all posts (public endpoint)',
      run: () => testEndpoint('posts', `${apiUrl}/posts`)
    },
    {
      name: 'Login',
      description: 'Test login with admin credentials',
      run: () => testEndpoint('login', `${apiUrl}/auth/login`, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
          email: 'admin@audrey.com',
          password: 'Admin123!'
        })
      })
    },
    {
      name: 'Direct Backend',
      description: 'Test connection to backend root',
      run: () => testEndpoint('root', '/api/health')
    }
  ];

  return (
    <div className="debug-page">
      <div className="debug-container">
        <h1>Backend Debug Panel</h1>
        <p className="debug-info">API URL: <strong>{apiUrl}</strong></p>
        
        <div className="test-grid">
          {tests.map(test => (
            <div key={test.name} className="test-card">
              <h3>{test.name}</h3>
              <p>{test.description}</p>
              <button 
                onClick={test.run}
                disabled={loading[test.name.toLowerCase().replace(' ', '')]}
                className="test-button"
              >
                {loading[test.name.toLowerCase().replace(' ', '')] ? 'Testing...' : 'Run Test'}
              </button>
              
              {results[test.name.toLowerCase().replace(' ', '')] && (
                <div className={`result ${results[test.name.toLowerCase().replace(' ', '')].success ? 'success' : 'error'}`}>
                  {results[test.name.toLowerCase().replace(' ', '')].success ? (
                    <>
                      <div className="result-status">
                        ✓ Status: {results[test.name.toLowerCase().replace(' ', '')].status}
                      </div>
                      <pre>{JSON.stringify(results[test.name.toLowerCase().replace(' ', '')].data, null, 2)}</pre>
                    </>
                  ) : (
                    <div className="result-error">
                      ✗ Error: {results[test.name.toLowerCase().replace(' ', '')].error}
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Debug;
